export default __webpack_public_path__ + "3948265df1b4bb36ae9cfb6280264e34.png";